import { render, staticRenderFns } from "./CoMessage.vue?vue&type=template&id=679ef478&scoped=true&"
import script from "./CoMessage.vue?vue&type=script&lang=ts&"
export * from "./CoMessage.vue?vue&type=script&lang=ts&"
import style0 from "./CoMessage.vue?vue&type=style&index=0&id=679ef478&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ef478",
  null
  
)

export default component.exports